import React from 'react';

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="text-xl font-semibold mb-4 text-gray-900">{title}</h2>
    <div className="text-gray-700">{children}</div>
  </div>
);

export default Section;
